import uuidv1 from 'uuid/v1'
import api from 'actions/api'
import config from 'config'
import { showError } from '../../../../../actions/index'

export const SWITCH_PAGE = 'switch_page'
export const SAVE_TRANSACTION_HISTORY = 'save_transaction_history'
export const SAVE_SESSION_ID = 'save_session_id'
export const SAVE_ACCOUNT_PROVIDERS = 'save_account_providers'

//const BANK_MERCHANT_ID = 'MSN9STXXBK7K'
//const BANK_SECRET = '2GWETB3ACWVQ4ZHT56E5GG873AP2669X'
const BANK_MERCHANT_ID = 'fc6d9988-bb68-407b-94e8-1e6e3fb4d59c'
const BANK_SECRET = 'E730wFA0EbWQyNd38Q7lCtfEhQIpo0vnyceQPjj2tYhqDGO8zx'

export const getBankToken = (callback, dispatch) => {
  //add the submit form

  //call login api
  dispatch(
    api.get(
      'http://41.216.166.83:8881/api/v1/clients/authenticate',
      {},
      response => callback(response.data.data),
      error => {
        console.log(error)
      },
      true,
      { auth: { username: BANK_MERCHANT_ID, password: BANK_SECRET } },
    ),
  )
}

export const switchPages = page => {
  return {
    type: SWITCH_PAGE,
    payload: page,
  }
}

export const saveSessionId = sessionId => {
  return {
    type: SAVE_SESSION_ID,
    payload: sessionId,
  }
}

export const saveTransactionHistory = transaction => {
  return {
    type: SAVE_TRANSACTION_HISTORY,
    payload: transaction,
  }
}

export const saveAccountProviders = providers => {
  return {
    type: SAVE_ACCOUNT_PROVIDERS,
    payload: providers,
  }
}

export const transferFunds = (request, onComplete) => (dispatch, getState) => {
  const transferRequest = {
    sourceAccountNumber: '2048714015',
    sourceAccountName: 'Monnify Limited',
    sourceBankCode: '000015',
    destinationAccountNumber: request.accountNumber,
    amount: request.amount,
    sessionId: getState().bankSimulator.sessionId,
    responseCode: '00',
    responseDescription: 'Approved',
    currency: 'NGN',
    transactionStatus: 'SUCCESSFUL',
  }

  const providerCode = request.bank || config.providerCode

  dispatch(
    api.post(
      `/account-provider/tsq-notification/${providerCode}`,
      transferRequest,
      () => {
        dispatch(
          saveTransactionHistory({
            name: 'Web-Transfer',
            reference: `WEB|${uuidv1()}|MONNIFY|PAYMENT${request.amount}`,
            amount: request.amount,
          }),
        )
        dispatch(switchPages('success'))
        onComplete()
      },
      error => {
        showError(error)
        console.log(error)
        onComplete()
      },
      true,
    ),
  )
}

export const getAccountName = (accountNumber, callback) => dispatch => {
  const sessionId = generateRandomString()
  dispatch(saveSessionId(sessionId))

  dispatch(
    api.post(
      '/account-provider/name-inquiry/71272',
      {
        accountNumber: accountNumber,
        sessionId: sessionId,
      },
      response => {
        callback(true, response.data.responseBody.accountName)
      },
      error => {
        callback(false)
      },
      true,
    ),
  )
}

const generateRandomString = (length = 32) => {
  var result = ''
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const getAllActiveAccountProviders = callback => dispatch => {
  dispatch(
    api.get(
      '/account-provider',
      {},
      response => {
        const accountProviders = response.data.responseBody || []
        dispatch(saveAccountProviders(accountProviders))
        callback(true, accountProviders)
      },
      error => {
        callback(false)
      },
      true,
    ),
  )
}



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/InternetBankingSimulatorApp/actions/index.js